import {createStrokeSVG} from './TEMPLATE'

// tabler: at
export const At_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M8 12a4 4 0 1 0 8 0a4 4 0 1 0 -8 0',
    'M16 12v1.5a2.5 2.5 0 0 0 5 0v-1.5a9 9 0 1 0 -5.5 8.28',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})

// tabler: at
export const At_Stroke2_Corner2_Rounded = createStrokeSVG({
  paths: [
    'M8 12a4 4 0 1 0 8 0a4 4 0 1 0 -8 0',
    'M16 12v1.5a2.5 2.5 0 0 0 5 0v-1.5a9 9 0 1 0 -5.5 8.28',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
